
import { defineComponent } from 'vue'
import AuthMixin from '~/mixins/authMixin'
import MetaMixin from '~/mixins/metaMixin'

export interface Testimonial {
  body?: string
  author?: string
  company?: string
  avatar?: string
}

const TESTIMONIALS: Testimonial[] = [
  {
    body: "DeepSource has made the code base <span class='text-transparent bg-clip-text bg-gradient-to-r from-lavender to-pink'> much more stable and dependable</span>. It allowed us to identify many more areas for improvement.",
    author: 'Piero Molino',
    company: 'Uber',
    avatar: 'testimonials/piero.png'
  },
  {
    body: "DeepSource provides a very nice <span class='text-transparent bg-clip-text bg-gradient-to-r from-lavender to-pink'>overview of issues</span> in our code.",
    author: 'Michal Čihař',
    company: 'Weblate',
    avatar: 'testimonials/michal.png'
  },
  {
    body: "DeepSource complements projects looking to embrace CI and source code quality as part of a larger DevOps strategy. It's been <span class='text-transparent bg-clip-text bg-gradient-to-r from-lavender to-pink'>very easy and a pleasure to use.</span>",
    author: 'Lewis McGibbney',
    company: 'NASA',
    avatar: 'testimonials/lewis.png'
  }
]

export default defineComponent({
  name: 'SignUp',
  mixins: [AuthMixin, MetaMixin],
  data() {
    return {
      testimonials: TESTIMONIALS
    }
  },
  head() {
    return {
      title: 'Sign up — DeepSource',
      link: [
        {
          rel: 'canonical',
          href: `https://${this.$config.domain}/signup`
        }
      ]
    }
  },
  middleware: [
    'redirectToHome',
    ({ $config, redirect, route }) => {
      if ($config.onPrem) {
        const { next } = route.query
        if (next) {
          redirect(302, { path: '/login', query: { next } })
        } else {
          redirect(302, '/login')
        }
      }
    }
  ],
  created() {
    this.metaTitle = 'Sign up - DeepSource'
    this.setCanonical = true
  }
})
